import React, {Component} from 'react';
import T from 'i18n-react';
import {connect} from 'react-redux';
// Style
import './ShopPage.css';
//Components
import TableFilters from "../../components/tableComponent/filters/TableFilters";
import DynamicTable from "../../components/tableComponent/dynamicTable/DynamicTable";
import ShopCard from "../../components/shopCard/ShopCard";
import {TableRowColumn} from 'material-ui/Table';
//Services
import ShopService from "../../services/ShopService";
import FilterService from "../../services/FilterService";
import {makeCancelable} from "../../utils/PromiseUtils";
import debounce from "lodash.debounce";
import {getDistinctValues} from "../../utils/JSUtils";

const mapStateToProps = (state) => ({
    idUser: state.userState.userData.idUser,
    userProfile: state.userState.userData.profile,
    language: state.languageState.language,
    clientList: state.userState.userData.clientList,
    buList: state.userState.userData.businessUnitList
});

const HEADER_LIST = ["name", "clientName", "codeClient", "buName", "codeBu","codeAl"];

class ShopPage extends Component {
    constructor(props) {
        super(props);

        const locationList = getDistinctValues(this.props.clientList.map(client => client.location));
        const hasOneLocation = locationList.length === 1;
        const location = hasOneLocation ? locationList[0] : null;

        this.state = {
            hasOneLocation,
            shopList: [],
            totalRowNumber: 0,
            numberOfRowsPerPage: 10,
            page: 1,
            error: null,
            isLoaded: false,
            selectedShop: null,
            displayShopCard: false,
            filterList: {
                location,
                client: null,
                bu: null,
                searchText: null,
            }
        };

        this._promises = [];
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        //Méthode avec debounce pour optimiser les appels (sur la recherche fulltext). cf. https://fr.reactjs.org/docs/faq-functions.html#debounce
        this.getShopListDebounced = debounce(this.getShopInformationList, 300);
        if(location){
            this.getShopInformationList();
        }
    }

    /**
     * Annulation de toutes les promesses encore en cours lorsque
     * l'on quitte le composant
     */
    componentWillUnmount() {
        this._promises.forEach(promise => promise.cancel());
        this.getShopListDebounced.cancel();
    }

    render() {
        return (
            <div className="shopPage">
                <TableFilters
                    searchedEntity="shop"
                    handleFilterChange={this.handleFilterChange}
                    resetFilters={this.resetFilters}
                    hasOneLocation={this.state.hasOneLocation}
                    clientList={this.props.clientList}
                    buList={this.props.buList}
                    {...this.state.filterList}
                />
                { this.state.filterList.location && this.state.shopList.length !== 0 ?
                    <div className="shopPageContent">
                        <DynamicTable
                            headerList={[...HEADER_LIST, ShopService.getShopLocationSpecificCodeLabel(this.state.filterList.location)]}
                            handleSelection={this.handleShopSelection.bind(this)}
                            renderColumns={this.renderColumns.bind(this)}
                            data={this.state.shopList}
                            fixedHeader={true}
                            selectable={true}
                            selected={this.state.selectedShop ? [this.state.selectedShop] : null}
                            page={this.state.page}
                            numberOfRowsPerPage={this.state.numberOfRowsPerPage}
                            totalRowNumber={this.state.totalRowNumber}
                            updatePagination={this.updatePagination.bind(this)}
                        >
                        </DynamicTable>
                    </div> : this.renderWarningMessage()
                }
                <div className="shopCardContainer">
                    { this.state.displayShopCard && this.state.selectedShop ?

                            <ShopCard
                                shop={this.state.selectedShop}
                                closeCard={this.closeCard}
                            /> : null
                    }
                </div>
            </div>
        );
    }

    renderColumns(rowIndex) {
        let columnList = HEADER_LIST.map((header, colIndex) =>
            <TableRowColumn key={colIndex} className="tooltipColumn">
                {this.state.shopList[rowIndex][header] ||  T.translate('tableFields.missingData')}
                <span className="hooverTextColumn">{this.state.shopList[rowIndex][header] ||  T.translate('tableFields.missingData')}</span>
            </TableRowColumn>
        );
        //On renvoie chaque colonne correspondant à la liste de header et on ajoute le code spécifique au pays dans la dernière colonne
        return columnList.concat(<TableRowColumn key={HEADER_LIST.length + 1}>{ShopService.getShopLocationSpecificCodeValue(this.state.shopList[rowIndex])}</TableRowColumn>)
    }

    renderWarningMessage(){
        let message;
        if(this.state.filterList.location && this.state.isLoaded){
            message = T.translate('shopPage.shopListEmpty');
        } else {
            message = T.translate('shopPage.selectLocation');
        }
        return (
            <div className="warningMessage">
                {message}
            </div>
        )
    }

    /**********************************************************
     ************************ Filtre  *************************
     **********************************************************/

    resetFilters(){
        this.setState((state) => ({
            filterList: {
                location: state.hasOneLocation ? state.filterList.location : null,
                client: null,
                bu: null,
                searchText: null,
            }}), this.closeCard);
    }

    handleFilterChange(filterKey, filterValue, debounce) {
        let filterList = this.state.filterList;
        filterList[filterKey] = filterValue;
        filterList = FilterService.syncFilters(filterKey, filterValue, filterList, this.props.clientList);
        this.setState({
            filterList,
            page: 1
        }, debounce ? this.getShopListDebounced : this.getShopInformationList);
    }

    handleShopSelection(selectedRows){
        const shopIndex = selectedRows[0];
        this.setState((state) => {
            return {
                selectedShop: state.shopList[shopIndex],
                displayShopCard: true
            }
        });
    }

    updatePagination(page, numberOfRowsPerPage){
        this.setState({
            page,
            numberOfRowsPerPage,
            selectedShop: null
        }, () => this.getShopInformationList());
    }

    closeCard = () => {
        this.setState({
            selectedShop: null,
            displayShopCard: false
        })
    };

    /**********************************************************
     * **************** Appels Web Service ********************
     **********************************************************/

    getShopInformationList = () => {
        const getShopInformationPromise = ShopService.getShopInformationList(
            this.state.page,
            this.state.numberOfRowsPerPage,
            this.state.filterList.location,
            this.state.filterList.client ? this.state.filterList.client.id : null,
            this.state.filterList.bu ? this.state.filterList.bu.id : null,
            this.state.filterList.search
        );

        const cancelablePromise = makeCancelable(getShopInformationPromise);
        this._promises.forEach(promise => promise.cancel());
        this._promises.push(cancelablePromise);

        cancelablePromise
            .promise
            .then(res => {
                this.setState({
                    shopList: res.resourceList,
                    totalRowNumber: res.total,
                    isLoaded: true
                }, this.closeCard)

            })
            .catch((error) => {
                if (!error.isCanceled) {
                    this.setState({
                        error
                    });
                }
            })
            .then(() => this.promiseFulfilled(cancelablePromise));
    };

    /**********************************************************
     * ************** Gestion des promises ******************
     **********************************************************/

    /**
     * On retire la promise de la liste des promises en cours
     * Cette fonction doit etre appelé après que la promise est rempli
     * @param promise
     */
    promiseFulfilled(promise) {
        const index = this._promises.indexOf(promise);

        if (index !== -1) {
            this._promises.splice(index, 1);
        }
    };
}

export default connect(mapStateToProps)(ShopPage);


// WEBPACK FOOTER //
// ./src/ui/shop/ShopPage.js